import { KYMW4200Model } from '../kymw4200.model';
import { CandidateGoodsSearchConditionModel } from '../vo/candidate-goods-search.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品マスタプルーフ候補一覧を取得する
 *
 * @export API通信成功時の処理
 * @class GetCandidateGoodsProofListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCandidateGoodsProofListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel および Vo
  private model: KYMW4200Model = null;
  private vo: CandidateGoodsSearchConditionModel = null;
  codeDiv: string;
  reserveNum1: string;
  successFunc: Function;
  private faultFunc: Function;

  // 選択Ｐコード
  public selectedPcode = String('');

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCandidateGoodsProofListService
   */
  private getBody(): PlessRequest {
    let combination = [];
    if (this.vo.pcode == null || PlessViewUtilsSub.isEmpty(this.vo.pcode)) {
      if (this.vo.pcodeList != null) {
        // リスト検索
        combination.push(...this.vo.pcodeList.map(pcode => {
          return {
            parameter: {
              PCode: pcode
            }
          }
        }))
      }
    } else {
      // 通常検索
      combination.push({
        parameter: {
          PCode: this.vo.pcode
        }
      })
    }

    // アイテムコード
    if (this.vo.itemCode == null || PlessViewUtilsSub.isEmpty(this.vo.itemCode)) {
      if (this.vo.itemCodeList != null) {
        // リスト検索
        combination.push(...this.vo.itemCodeList.map(itemCode => {
          return {
            parameter: {
              ItemCode: itemCode
            }
          }
        }))
      }
    } else {
      // 通常検索
      combination.push({
        parameter: {
          ItemCode: this.vo.itemCode
        }
      })
    }

    // 商品名
    combination.push(...this.vo.guideGoodsNameList.map(guideGoodsName => {
      return {
        parameter: {
          GuideGoodsName: guideGoodsName
        }
      }
    }))

    // 規格名
    combination.push(...this.vo.guideStandardNameList.map(guideStandardName => {
      return {
        parameter: {
          GuideStandardName: guideStandardName
        }
      }
    }))

    // タグ
    combination.push(...this.vo.tagIdList.map(tagId => {
      return {
        parameter: {
          TagId: tagId
        }
      }
    }))

    // 商品マーク
    combination.push(...this.vo.goodsMarkList.map(goodsMark => {
      return {
        parameter: {
          GoodsMark: goodsMark
        }
      }
    }))

    // 単協コード
    combination.push(...this.vo.coopCodeList.map(coopCode => {
      return {
        parameter: {
          CoopCode: coopCode
        }
      }
    }))

    return new PlessRequest({
      search: {
        Rec: {
          parameter: {
            EbaseSpecCode: this.vo.ebaseSpecCode,
            DataType: this.vo.dataType,
            JANCode: this.vo.janCode,
            MakerName: this.vo.makerName,
            TagSearchType: this.vo.tagSearchType,
            GoodsMarkSearchType: this.vo.goodsMarkSearchType,
            OrdrClientCode: this.vo.ordrClientCode,
            OrdrClientKanji: this.vo.ordrClientKanji,
            PayeeClientCode: this.vo.payeeClientCode,
            PayeeClientKanji: this.vo.payeeClientKanji,
            ClassCode: this.vo.classCode,
            MiddleClassCode: this.vo.middleClassCode,
            SmallClassCode: this.vo.smallClassCode,
            RegistDateFrom: this.vo.registDateFrom,
            RegistDateTo: this.vo.registDateTo,
            UpdateDateFrom: this.vo.updateDateFrom,
            UpdateDateTo: this.vo.updateDateTo,
            AdmitStatus: this.vo.admitStatus,
            GoodsDiv: this.vo.goodsDiv,
            BuyerCode: this.vo.buyerCode,
            PageNo: this.vo.pageNo,
            SortKey: this.vo.sortKey,
            OrderKey: this.vo.orderKey,
            DataKbnFlg: this.vo.dataKbnFlg,
          },
          combination: combination,
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {*} model
   * @param {*} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @param {Function} [faultFunc=null] 失敗時後続処理
   * @memberof GetCandidateGoodsProofListService
   */
  execute(model: any, vo: any, successFunc: Function = null, faultFunc: Function = null) {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.faultFunc = faultFunc;
    this.send('KYMW42getCandidateGoodsProofList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCandidateGoodsProofListService
   */
  success(data: any) {
    this.model.setCandidateGoodsProofList(data);
    if (this.successFunc !== null) {
      this.successFunc(this.selectedPcode);
    }
  }

  /**
   * API通信失敗時の処理
   *
   * @param {*} errList レスポンスデータ
   * @memberof GetCandidateGoodsProofListService
   */
  plessErrorHandler(errList: Object): void {
    if ((this.faultFunc === undefined || this.faultFunc === null)) return;
    this.faultFunc();
  }
}
